import React from 'react';
import {
  Route,
  Routes,
} from 'react-router-dom';
import Apps from './apps';
import Profile from '../Profile';

const Admin = () => {
  return (
    <Routes>
      <Route path={`/apps/*`} element={<Apps />} />
      <Route path={`/profile/*`} element={<Profile />} />
    </Routes>
  );
};

export default Admin;
